// WHOOP-style circular score ring with an animated gradient stroke.
const TONE_STOPS: Record<string, [string, string]> = {
  success: ['#5eb55e', '#008000'],
  warning: ['#f8cd4f', '#d6a100'],
  alert: ['#ff9114', '#bd1c00'],
}

export function HealthRing({
  score,
  tone = 'warning',
  size = 132,
  stroke = 12,
  label,
}: {
  score: number
  tone?: 'success' | 'warning' | 'alert'
  size?: number
  stroke?: number
  label?: string
}) {
  const r = (size - stroke) / 2
  const circ = 2 * Math.PI * r
  const offset = circ * (1 - score / 100)
  const [c0, c1] = TONE_STOPS[tone]
  const gid = `ring-${tone}`
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={c0} />
            <stop offset="1" stopColor={c1} />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--muted)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={`url(#${gid})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          style={{
            // animate from empty → score
            ['--ring-circ' as string]: `${circ}`,
            ['--ring-offset' as string]: `${offset}`,
            strokeDashoffset: offset,
            animation: 'sara-ring 1s cubic-bezier(0.22,1,0.36,1) both',
          }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-3xl font-bold leading-none text-foreground">{score}</span>
        {label && <span className="mt-0.5 text-[11px] font-medium text-muted-foreground">{label}</span>}
      </div>
    </div>
  )
}
